import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@wds/card';
import { Box } from '@wds/box';
import AppCard from '../AppCard';
import useStyles from './styles';

const AppsGrid = ({ apps = [] }) => {
  const { appGrid } = useStyles();
  return (
    <Box className={appGrid}>
      <Card.Grid>{apps.map(app => app && <AppCard key={`${app.encryptedAppId}`} app={app} />)}</Card.Grid>
    </Box>
  );
};

AppsGrid.propTypes = {
  apps: PropTypes.arrayOf(
    PropTypes.shape({
      encryptedAppId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      tagline: PropTypes.string.isRequired,
      image: PropTypes.string,
      link: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};

export default AppsGrid;
